import { call, put, takeEvery } from "redux-saga/effects";
import { DeclarationTypes } from "./actionTypes";
import { API } from "src/util/api";
import { createDeclarationFormError, createDeclarationFormSuccess, getDeclarationFormByIdError, getDeclarationFormByIdSuccess, getDeclarationListError, getDeclarationListSuccess, getManufacturerDropdownError, getManufacturerDropdownSuccess, mailDeclarationFormError, mailDeclarationFormSuccess, printDeclarationFormError, printDeclarationFormSuccess } from "./actions";

function* fetchDeclarations(action: any) {
  try {
    const response: Promise<any> = yield call(API.getDeclarationList, { ...action.lazyState });
    yield put(getDeclarationListSuccess(response));
  } catch (error) {
    yield put(getDeclarationListError(error));
  }
}

function* fetchManufacturerDropdown(action: any) {
  try {
    const response: Promise<any> = yield call(API.getManufacturerDropdown);
    yield put(getManufacturerDropdownSuccess(response));
  } catch (error) {
    yield put(getManufacturerDropdownError(error));
  }
}

function* fetchDeclarationById(action: any) {
  try {
    const response: Promise<any> = yield call(API.getDeclarationFormById,action.payload);
    yield put(getDeclarationFormByIdSuccess(response));
  } catch (error) {
    yield put(getDeclarationFormByIdError(error));
  }
}

function* createDeclarationFormAsync(action: any) {
  try {
        if(action.payload.id){
          const response: Promise<any> = yield call(API.updateDeclarationForm,action.payload.data,action.payload.id);
          yield put(createDeclarationFormSuccess("Delivery Challan Updated Successfully"));

    }else{
          const response: Promise<any> = yield call(API.createDeclarationForm,action.payload.data);
          yield put(createDeclarationFormSuccess("Delivery Challan Created Successfully"));
    }
  } catch (error) {
    yield put(createDeclarationFormError(error));
  }
}

function* printDeclarationById(action: any) {
  try {
    const response: Promise<any> = yield call(API.printDeclarationForm,action.payload);
    yield put(printDeclarationFormSuccess(response));
  } catch (error) {
    yield put(printDeclarationFormError(error));
  }
}

function* mailDeclarationById(action: any) {
  try {
    const response: Promise<any> = yield call(API.mailDeclarationForm,action.payload);
    yield put(mailDeclarationFormSuccess(response));
  } catch (error) {
    yield put(mailDeclarationFormError(error));
  }
}

function* declarationSaga() {
  yield takeEvery(DeclarationTypes.GET_DECLARATION_LOADING, fetchDeclarations);
  yield takeEvery(DeclarationTypes.GET_MANUFACTURER_DROPDOWN_LOADING, fetchManufacturerDropdown);
  yield takeEvery(DeclarationTypes.GET_DECLARATION_BY_ID_LOADING, fetchDeclarationById);
  yield takeEvery(DeclarationTypes.CREATE_DECLARATION_FORM_LOADING, createDeclarationFormAsync);
  yield takeEvery(DeclarationTypes.PRINT_DECLARATION_FORM_LOADING, printDeclarationById);
  yield takeEvery(DeclarationTypes.MAIL_DECLARATION_FORM_LOADING, mailDeclarationById);
}

export default declarationSaga;